import { render, staticRenderFns } from "./courseDaySessionsList.vue?vue&type=template&id=19023ce1&scoped=true&lang=pug&"
import script from "./courseDaySessionsList.vue?vue&type=script&lang=js&"
export * from "./courseDaySessionsList.vue?vue&type=script&lang=js&"
import style0 from "./courseDaySessionsList.vue?vue&type=style&index=0&id=19023ce1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19023ce1",
  null
  
)

export default component.exports